exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-0a384065] {\n\ttransition: opacity 0.2s ease-in-out;\n}\n", ""]);

// exports
